
import React, { useState, useEffect } from "react";
import { CheckCircle } from "lucide-react";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { YEARS } from "../VehicleConstants";

interface YearSelectProps {
  value: string;
  onChange: (value: string) => void;
}

const YearSelect = ({ value, onChange }: YearSelectProps) => {
  const [selected, setSelected] = useState(false);
  
  useEffect(() => {
    setSelected(value !== "");
  }, [value]);
  
  return (
    <div className="space-y-2">
      <label htmlFor="vehicleYear" className="block text-sm font-medium text-black">
        Year of Vehicle
      </label>
      <div className="relative">
        <Select value={value} onValueChange={(value) => {
          onChange(value);
          setSelected(true);
        }}>
          <SelectTrigger id="vehicleYear" className="bg-white text-black border-gray-300">
            <SelectValue placeholder="Select" />
          </SelectTrigger>
          <SelectContent>
            {YEARS.map(year => (
              <SelectItem key={year} value={year}>
                {year}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        {selected && (
          <CheckCircle className="absolute right-10 top-1/2 transform -translate-y-1/2 h-5 w-5 text-green-500" />
        )}
      </div>
    </div>
  );
};

export default YearSelect;
